import React, {createContext, Key, ReactNode, useContext, useState} from 'react';

interface NegotiationEmittedTableContextType {
    page: number;
    pageSize: number;
    ordering: string | undefined;
    setPage: (page: number) => void;
    setPageSize: (pageSize: number) => void;
    setOrdering: (ordering: string) => void;
    brokerName: Key[];
    setBrokerName: (brokerName: Key[]) => void;
}

const NegotiationEmittedTableContext = createContext<NegotiationEmittedTableContextType | undefined>(undefined);

export const NegotiationEmittedTableProvider: React.FC<{ children: ReactNode }> = ({children}) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [ordering, setOrdering] = useState<string | undefined>(undefined);
    const [brokerName, setBrokerName] = useState<Key[]>([]);

    const value: NegotiationEmittedTableContextType = {
        page,
        setPage,
        pageSize,
        setPageSize,
        ordering,
        setOrdering,
        brokerName,
        setBrokerName,

    };

    return (
        <NegotiationEmittedTableContext.Provider value={value}>
            {children}
        </NegotiationEmittedTableContext.Provider>
    );
};

export const useNegotiationEmittedTable = (): NegotiationEmittedTableContextType => {
    const context = useContext(NegotiationEmittedTableContext);
    if (context === undefined) {
        throw new Error('useLinkedEmittedTable deve essere utilizzato all\'interno di un NegotiationEmittedTableProvider');
    }
    return context;
};